import { Button } from './ui/button';
import { track } from '../lib/api';
import { trackPixelEvent } from '../lib/pixels';

export default function OrDoNothing({ settings, geo }) {
  const tg = settings?.telegram_link || '#';

  function fire() {
    trackPixelEvent('Subscribe', { source: 'ordonothing' });
    track({ type: 'tg_click', country_code: geo?.country_code, country_name: geo?.country_name, source: 'ordonothing' });
  }

  return (
    <section className="section-pad bg-[hsl(240_6%_7%)] border-t border-b border-border">
      <div className="container-x grid gap-10 lg:grid-cols-2 items-center">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(0_84%_62%)] mb-2">Or Do Nothing…</div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl leading-[0.95]">GO WATCH NETFLIX.<br/>WORK A 9–5.</h2>
          <p className="text-[hsl(0_0%_82%)] mt-5 leading-relaxed max-w-xl">
            Keep scrolling. Keep consuming. Keep telling yourself “next month.” The timing will never be perfect.
            Every day spent on the outside is a day the traders inside pull further ahead.
          </p>
          <p className="text-[hsl(0_0%_82%)] mt-4 leading-relaxed max-w-xl">
            The difference between people building wealth right now and people watching it happen isn’t talent, luck, or connections. It’s a single decision, made at a single moment.
          </p>
        </div>
        <div className="relative rounded-3xl card-surface p-8 text-center gold-hairline">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)]">Lock In Your Spot</div>
          <div className="font-display uppercase text-4xl sm:text-5xl mt-3">FREE ENTRY WON’T STAY OPEN FOREVER.</div>
          <p className="text-sm text-muted-foreground mt-3">131,000+ traders already inside. Start free today — upgrade to Elite whenever you’re ready.</p>
          <a href={tg} target="_blank" rel="noreferrer" onClick={fire} data-testid="ordonothing-join-button">
            <Button className="mt-6 cta-sheen border-0 text-white font-semibold h-12 px-6">Join Free Telegram</Button>
          </a>
        </div>
      </div>
    </section>
  );
}
